module.exports = __webpack_public_path__ + "img/6.502cda71.svg";